import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type PartnerInvoiceDetailFragment = { __typename?: 'PartnerInvoice', id: string, label?: string | null, title?: string | null, store_id?: string | null, note?: string | null, url?: string | null, invoice_number?: string | null, status?: Types.BillomatInvoiceStatus | null, parsed_amount?: string | null, parsed_payment_direction?: string | null, total_net?: string | null, total_gross?: string | null, hidden?: boolean | null, date?: string | null, admin_info?: { __typename?: 'BillomatInvoice', id: string, status?: Types.BillomatInvoiceStatus | null, title?: string | null, label?: string | null, generated_at?: string | null, send_processed_at?: string | null, send_at?: string | null, send_status?: Types.BillomatInvoiceSendStatus | null, send_error?: string | null, send_emails_used?: string | null, send_delivery_id?: string | null, send_delivery_link?: string | null, charged_at?: string | null, charged_amount?: number | null, charged_currency?: Types.Currency | null, charged_transaction_id?: string | null, charged_charge_id?: string | null } | null };

export const PartnerInvoiceDetailFragmentDoc = gql`
    fragment PartnerInvoiceDetail on PartnerInvoice {
  id
  label
  title
  store_id
  note
  url
  invoice_number
  status
  parsed_amount
  parsed_payment_direction
  total_net
  total_gross
  hidden
  date
  admin_info {
    id
    status
    title
    label
    generated_at
    send_processed_at
    send_at
    send_status
    send_error
    send_emails_used
    send_delivery_id
    send_delivery_link
    charged_at
    charged_amount
    charged_currency
    charged_transaction_id
    charged_charge_id
  }
}
    `;